import React, { Component } from 'react';
import Navbar from "../../components/Navbar";
import Footer from "../../components/Footer";
import { Carousel, Input } from 'antd';
import moment from 'moment';
import 'moment/locale/th';
import Swal from "sweetalert2";



import { apiGetBanner, apiGetListPromotiion } from '../../services/api/promotion';

import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import 'antd/dist/antd.css';
import './style/promotion.scss';






const { Search } = Input;

class Promotion extends Component {

    constructor(props) {
        super(props);

        this.state = {
            banner: [],
            list: []
        };
    }



    componentDidMount() {
        this.getBannerPromotion();
        this.getListPromotion();

    }

    getBannerPromotion = async () => {
        let resbanner = await apiGetBanner()
        if (resbanner && resbanner.status) {
            // console.log(resbanner)
            if (resbanner.status == 200) {
                this.setState({
                    banner: resbanner.data.result
                })
            }
        } else {
            console.log(resbanner)
        }

    }

    getListPromotion = async () => {
        let reslist = await apiGetListPromotiion()
        if (reslist && reslist.status) {
            // console.log(reslist)
            if (reslist.status == 200) {
                this.setState({
                    list: reslist.data.result
                })
            }
        } else {
            console.log(reslist)
        }
    }



    onSearch = value => console.log(value);


    render() {




        return (
            <div className="cover-promotion">
                <div className="wh-bg">
                    <div className="container">
                        <Navbar />
                    </div>
                </div>

                <div className="box-promotion container">
                    <div className="box-list">
                        <div className="banner">
                            <Carousel autoplay>

                                {
                                    this.state.banner != [] ? this.state.banner.map(value => {
                                        return <div key={value.banner_id}>
                                            <img className="imgbanner img-fluid" src={value.banner_url} alt="" />
                                            {/* {console.log(value)} */}
                                        </div>
                                        
                                    }) : null
                                }
                            </Carousel>
                        </div>
                        <div className="bx-show">
                            <div className="bx-grid">
                                <h3 className="hdpro">โปรโมชั่น</h3>
                                <div className="tab-search">
                                    <Search className="bx-search" placeholder="ค้นหาโปรโมชั่น!" onSearch={this.onSearch} style={{ width: 200 }} />
                                </div>
                            </div>
                            <hr className="brhd" />

                            <div className="list-pro-bx">
                                <div className="row cov-list">
                                    {
                                        this.state.list != [] ? this.state.list.map(data => {
                                            return <div className="col-lg-4 col-md-4 col-6 col-pro">
                                                <div className="cov-pro" key={data.promotion_id}>
                                                    <div className="img-pro">
                                                        <img src={data.promotion_image ? data.promotion_image : "/img/pic/cover.png"} alt="" className="img-fluid" />
                                                    </div>
                                                    <div className="des">
                                                        <p className="hd-pro">{data.promotion_code}</p>
                                                        <p className="discount"><img src="/img/icon/discount.png" alt="" className="img-fluid" /> ลดสูงสุด {data.value} {data.type == "BATH" ? "บาท" : "%"}</p>
                                                        <p className="date"><img src="/img/icon/calendar.png" alt="" className="img-fluid" /> {moment(data.start_date).format("DD/MM/YYYY")} - {moment(data.end_date).format("DD/MM/YYYY")}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        })
                                            : null
                                    }


                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Footer />
            </div>
        )
    }
}

export default Promotion;
